import { populate } from "populate";

const raw = {
  width: 1360,
  height: 760,
  x: 0,
  y: 0,
  list: [
    {
      id: "d61f7a2e-cad4-4612-af24-663d994818cc",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "86e61955-5900-4f5c-881e-d38f0762ff4a",
      type: "Sprite",
      name: "henry",
      nameSpace: "",
      className: "",
      x: 1286,
      y: 760,
      anchor: {
        x: 0.8,
        y: 1
      },
      pivot: {
        x: 1,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "farm_henry",
      parent: "d61f7a2e-cad4-4612-af24-663d994818cc",
      data: ""
    },
    {
      id: "65a30321-2f55-45cf-9f58-80bf5b89c8e2",
      type: "Text",
      name: "continueText",
      nameSpace: "",
      className: "",
      x: 699,
      y: 612,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "ClickToContinue",
      localize: true,
      maxWidth: 1000,
      maxHeight: 200,
      maxFontSize: 100,
      icons: [],
      style: {
        fontSize: 100,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "white",
        stroke: "#5c5c5c",
        strokeThickness: 3,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: true,
        dropShadowAlpha: 0.3,
        dropShadowAngle: 1.3,
        dropShadowBlur: 4,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "d61f7a2e-cad4-4612-af24-663d994818cc",
      data: ""
    },
    {
      id: "e57a5f3c-7824-4932-a921-d9bf912a3692",
      type: "NineSlicePlane",
      name: "dialog",
      nameSpace: "",
      className: "",
      x: -456,
      y: -569,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 267,
        y: 94
      },
      width: 534,
      height: 198,
      leftWidth: 0,
      topHeight: 0,
      rightWidth: 0,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ftux_dialog",
      parent: "86e61955-5900-4f5c-881e-d38f0762ff4a",
      data: ""
    },
    {
      id: "a504f376-5538-4b11-9e31-2cac6032e4df",
      type: "Sprite",
      name: "dialog_tail",
      nameSpace: "",
      className: "",
      x: 453,
      y: 180,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 1,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "ftux_dialog_tail",
      parent: "e57a5f3c-7824-4932-a921-d9bf912a3692",
      data: ""
    },
    {
      id: "653b78f6-e717-4ed1-824f-5a7744c784b7",
      type: "Text",
      name: "dialog_text",
      nameSpace: "",
      className: "",
      x: 269,
      y: 92,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "FarmFTUX2",
      localize: true,
      maxWidth: 480,
      maxHeight: 200,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#bb3c2f",
        stroke: "black",
        strokeThickness: 0,
        align: "left",
        wordWrap: true,
        wordWrapWidth: 480,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "e57a5f3c-7824-4932-a921-d9bf912a3692",
      data: ""
    }
  ]
} as const;

export class FarmFTUXLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  henry: GameObject<PIXI.Sprite>;
  dialog: GameObject<PIXI.NineSlicePlane>;
  dialog_tail: GameObject<PIXI.Sprite>;
  dialog_text: GameObject<PIXI.Text>;
  continueText: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
